import { createSlice } from '@reduxjs/toolkit';
import { AxiosResponseModel } from '../../@types/base';
import { DashboardCountsModel, DashboardModel } from '../../@types/dashboard';
import { CONSTS } from './const';
import { dispatch } from '../store';
import axios from '../../utils/axios';
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';

// ----------------------------------------------------------------------

type DashboardState = {
  dashboardCountsError: boolean;
  isDashboardCountsLoading: boolean;
  dashboardCounts: DashboardCountsModel;

  createDashboardModalIsOpen: boolean;
  updateDashboardModalIsOpen: boolean;
};

const dashboardCountsInit: DashboardCountsModel = {
  camCount: 0,
  brightIQCamCount: 0,
  userCount: 0,
  locationCount: 0
};

const initialState: DashboardState = {

  dashboardCountsError: false,
  isDashboardCountsLoading: false,
  dashboardCounts: dashboardCountsInit,

  createDashboardModalIsOpen: false,
  updateDashboardModalIsOpen: false
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {

    // START DASHBOARD COUNTS LOADING
    startDashboardCountsLoading(state) {
      state.isDashboardCountsLoading = true;
    },

    // HAS ERROR DASHBOARD COUNTS
    hasErrorDashboardCounts(state, action) {
      state.isDashboardCountsLoading = false;
      state.dashboardCountsError = action.payload;
    },

    // GET DASHBOARD COUNTS
    getDashboardCountsSuccess(state, action) {
      state.isDashboardCountsLoading = false;
      state.dashboardCounts = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {} = slice.actions;

// ----------------------------------------------------------------------
// DASHBOARD COUNT

export async function getDashboardCountsWithReturn() {
  dispatch(slice.actions.startDashboardCountsLoading());
  try {
    const response: AxiosResponseModel<DashboardModel> = await axios
      .get(CONSTS.DASHBOARD_GET_GET_DASHBOARD_COUNTS)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(slice.actions.getDashboardCountsSuccess(response.data?.data));
    } else {
      dispatch(slice.actions.getDashboardCountsSuccess([]));
    }
    return response;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorDashboardCounts(error));
    return error.response.data;
  }
}

// ----------------------------------------------------------------------
